import * as React from 'react';
import { FOOTER } from '../../utils/dataTrackingValues.js';
import Brandy from '../Brandy/index.js';
import Link from '../Link/index.js';
import { Footer as Footer$2, TopSection, BottomSection, Nav, GroupLabel, LegalSection } from './Footer.styles.js';
import { TopSection as TopSection$1, BottomSection as BottomSection$1 } from './FooterModule.styles.js';

var Footer = function Footer(_ref) {
  var _ref$bottomSectionMod = _ref.bottomSectionModule,
    bottomSectionModule = _ref$bottomSectionMod === void 0 ? null : _ref$bottomSectionMod,
    requestId = _ref.requestId,
    _ref$logo = _ref.logo,
    logo = _ref$logo === void 0 ? null : _ref$logo,
    _ref$logoLink = _ref.logoLink,
    logoLink = _ref$logoLink === void 0 ? null : _ref$logoLink,
    _ref$CustomLink = _ref.CustomLink,
    CustomLink = _ref$CustomLink === void 0 ? null : _ref$CustomLink,
    _ref$disclaimers = _ref.disclaimers,
    disclaimers = _ref$disclaimers === void 0 ? [] : _ref$disclaimers,
    _ref$disclaimerBackgr = _ref.disclaimerBackgroundColor,
    disclaimerBackgroundColor = _ref$disclaimerBackgr === void 0 ? null : _ref$disclaimerBackgr,
    _ref$disclaimerTextCo = _ref.disclaimerTextColor,
    disclaimerTextColor = _ref$disclaimerTextCo === void 0 ? null : _ref$disclaimerTextCo,
    _ref$logoBackgroundCo = _ref.logoBackgroundColor,
    logoBackgroundColor = _ref$logoBackgroundCo === void 0 ? null : _ref$logoBackgroundCo,
    _ref$logoBottomBorder = _ref.logoBottomBorder,
    logoBottomBorder = _ref$logoBottomBorder === void 0 ? null : _ref$logoBottomBorder,
    _ref$logoTextColor = _ref.logoTextColor,
    logoTextColor = _ref$logoTextColor === void 0 ? null : _ref$logoTextColor,
    _ref$logoTopBorder = _ref.logoTopBorder,
    logoTopBorder = _ref$logoTopBorder === void 0 ? null : _ref$logoTopBorder,
    _ref$navData = _ref.navData,
    navData = _ref$navData === void 0 ? [] : _ref$navData,
    _ref$navigationBackgr = _ref.navigationBackgroundColor,
    navigationBackgroundColor = _ref$navigationBackgr === void 0 ? null : _ref$navigationBackgr,
    _ref$navigationTextCo = _ref.navigationTextColor,
    navigationTextColor = _ref$navigationTextCo === void 0 ? null : _ref$navigationTextCo,
    _ref$topSectionModule = _ref.topSectionModule,
    topSectionModule = _ref$topSectionModule === void 0 ? null : _ref$topSectionModule;
  var navBackgroundColor = (navigationBackgroundColor === null || navigationBackgroundColor === void 0 ? void 0 : navigationBackgroundColor.toLowerCase()) || '';
  var navTextColor = (navigationTextColor === null || navigationTextColor === void 0 ? void 0 : navigationTextColor.toLowerCase()) || '';
  var discTextColor = (disclaimerTextColor === null || disclaimerTextColor === void 0 ? void 0 : disclaimerTextColor.toLowerCase()) || '';
  var discBackgroundColor = (disclaimerBackgroundColor === null || disclaimerBackgroundColor === void 0 ? void 0 : disclaimerBackgroundColor.toLowerCase()) || '';
  var imageBackgroundColor = (logoBackgroundColor === null || logoBackgroundColor === void 0 ? void 0 : logoBackgroundColor.toLowerCase()) || '';
  var imageTextColor = (logoTextColor === null || logoTextColor === void 0 ? void 0 : logoTextColor.toLowerCase()) || '';
  var logoTopBorderValue = (logoTopBorder === null || logoTopBorder === void 0 ? void 0 : logoTopBorder.toLowerCase()) || '';
  var logoBottomBorderValue = (logoBottomBorder === null || logoBottomBorder === void 0 ? void 0 : logoBottomBorder.toLowerCase()) || '';
  var FooterLink = CustomLink || Link;
  return /*#__PURE__*/React.createElement(Footer$2, {
    className: "leshen-footer",
    navigationBackgroundColor: navBackgroundColor
  }, /*#__PURE__*/React.createElement(TopSection, {
    className: "top-section",
    logoBackgroundColor: imageBackgroundColor,
    logoTextColor: imageTextColor,
    logoTopBorder: logoTopBorderValue,
    logoBottomBorder: logoBottomBorderValue
  }, /*#__PURE__*/React.createElement(Link, {
    to: "".concat(logoLink || '#')
  }, /*#__PURE__*/React.isValidElement(logo) ? logo : /*#__PURE__*/React.createElement("span", null, logo)), topSectionModule && /*#__PURE__*/React.createElement(TopSection$1, {
    className: "top-section-right"
  }, topSectionModule)), navData.length > 0 && /*#__PURE__*/React.createElement(BottomSection, {
    className: "bottom-section",
    navigationBackgroundColor: navBackgroundColor,
    navigationTextColor: navTextColor
  }, navData.map(function (_ref2) {
    var text = _ref2.text,
      href = _ref2.href,
      link = _ref2.link,
      _ref2$subnav = _ref2.subnav,
      subnav = _ref2$subnav === void 0 ? [] : _ref2$subnav;
    return /*#__PURE__*/React.createElement(Nav, {
      key: text,
      className: "nav"
    }, /*#__PURE__*/React.createElement(GroupLabel, {
      variant: "feature"
    }, href ? /*#__PURE__*/React.createElement(FooterLink, {
      to: href || link
    }, text) : text), subnav.map(function (_ref3) {
      var _FOOTER$LINKS, _FOOTER$LINKS$handleC;
      var subnavLink = _ref3.link,
        subnavHref = _ref3.href,
        subNavText = _ref3.text;
      var subHref = subnavLink || subnavHref;
      return /*#__PURE__*/React.createElement(FooterLink, {
        className: "link",
        key: subNavText,
        to: subHref,
        onClick: FOOTER === null || FOOTER === void 0 || (_FOOTER$LINKS = FOOTER.LINKS) === null || _FOOTER$LINKS === void 0 || (_FOOTER$LINKS$handleC = _FOOTER$LINKS.handleClick) === null || _FOOTER$LINKS$handleC === void 0 ? void 0 : _FOOTER$LINKS$handleC.call(_FOOTER$LINKS, subHref, subNavText, requestId)
      }, subNavText);
    }));
  }), bottomSectionModule && /*#__PURE__*/React.createElement(BottomSection$1, {
    className: "bottom-right",
    navigationBackgroundColor: navigationBackgroundColor,
    navigationTextColor: navigationTextColor
  }, bottomSectionModule)), disclaimers && disclaimers.length > 0 && /*#__PURE__*/React.createElement(LegalSection, {
    disclaimerBackgroundColor: discBackgroundColor,
    disclaimerTextColor: discTextColor,
    className: "legal-section"
  }, disclaimers === null || disclaimers === void 0 ? void 0 : disclaimers.map(function (disclaimer) {
    return /*#__PURE__*/React.createElement(Brandy, {
      className: "brandy",
      key: disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.id,
      text: disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.text,
      symbol: disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.symbol,
      variant: "legal"
    });
  })));
};
var Footer$1 = Footer;

export { Footer$1 as default };
//# sourceMappingURL=index.js.map
